"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loaderReducer = loaderReducer;
var _types = require("./types");
var _types2 = require("../game/types");
var initialState = {
  preProgress: 0,
  progress: 0,
  status: _types.LoaderStatus.Initiating,
  bgStatus: _types.LoaderStatus.Initiating,
  translationsLoaded: false,
  languageFiles: 0,
  languageFilesLoaded: 0,
  initTime: new Date()
};
function loaderReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.LOAD:
      {
        var newState = Object.assign({}, state, {});
        if (action.payload.metadata && action.payload.metadata.languageFile) newState.languageFiles++;
        return newState;
      }
    case _types2.GAME_READY:
      {
        return Object.assign({}, state, {
          finishedTime: new Date()
        });
      }
    case _types.LANGUAGE_FILE_LOADED:
      {
        return Object.assign({}, state, {
          languageFilesLoaded: state.languageFilesLoaded + 1
        });
      }
    case _types.LOADER_PROGRESS:
      {
        var _newState = Object.assign({}, state, {
          progress: action.payload
        });
        return _newState;
      }
    case _types.PRE_LOADER_PROGRESS:
      {
        var _newState2 = Object.assign({}, state, {
          preProgress: action.payload
        });
        return _newState2;
      }
    case _types.LOADING_STARTED:
      {
        var _newState3 = Object.assign({}, state, {
          status: _types.LoaderStatus.Loading
        });
        return _newState3;
      }
    case _types.LOADING_COMPLETED:
      {
        var _newState4 = Object.assign({}, state, {
          status: _types.LoaderStatus.Completed
        });
        return _newState4;
      }
    case _types.LOAD_FAILED:
      {
        var _newState5 = Object.assign({}, state, {
          status: _types.LoaderStatus.Failed
        });
        return _newState5;
      }
    case _types.LOADED_TRANSLATIONS:
      {
        var _newState6 = Object.assign({}, state, {
          translationsLoaded: true
        });
        return _newState6;
      }
    case _types.BG_LOADING_COMPLETE:
      {
        return Object.assign({}, state, {
          bgStatus: _types.LoaderStatus.Completed
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map